import { createContext, useContext } from "react";

import { SupportedLocales } from "./config";

export interface LocaleContextData {
  locale: string;
}

export const defaultLayoutContextValue: LocaleContextData = {
  locale: SupportedLocales.EN,
};

export const LocaleContext = createContext(defaultLayoutContextValue);

export const useLocaleContext = () => useContext(LocaleContext);
